import React,{useRef,useEffect}from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import {H1,P,Errors}from'@manulife/mux';import YesNoModal from'../YesNoModal/YesNoModal.js';import FormattedRichMessage from'../FormattedRichMessage/FormattedRichMessage.js';function LogoutModal(_ref) {
  var showModal = _ref.showModal,
    onYes = _ref.onYes,
    onNo = _ref.onNo,
    error = _ref.error;
  var intl = useIntl();
  var titleModalRef = useRef();
  useEffect(function () {
    var _titleModalRef$curren;
    (_titleModalRef$curren = titleModalRef.current) === null || _titleModalRef$curren === void 0 ? void 0 : _titleModalRef$curren.focus();
  }, [titleModalRef]);
  return /*#__PURE__*/React.createElement(YesNoModal, {
    showModal: showModal,
    onNo: onNo,
    onYes: onYes,
    ariaLabelledById: "yesNo-modal-title"
  }, /*#__PURE__*/React.createElement(H1, {
    id: "yesNo-modal-title",
    ref: titleModalRef,
    tabIndex: "-1",
    disableFocusOutline: true
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "shared.layout.logoutModal.title"
  })), /*#__PURE__*/React.createElement(P, null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "shared.layout.logoutModal.message"
  })), error && /*#__PURE__*/React.createElement(Errors, {
    errors: [intl.formatMessage({
      id: 'shared.layout.logoutModal.error.message'
    })],
    id: "errorLogoutModal"
  }));
}
process.env.NODE_ENV !== "production" ? LogoutModal.propTypes = {
  showModal: PropTypes.bool,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  error: PropTypes.bool
} : void 0;
LogoutModal.defaultProps = {
  showModal: false,
  error: false
};export{LogoutModal as default};